module.exports = __webpack_public_path__ + "img/89589c7.svg";